import { parseValueAsDate } from "../common/components/component-helpers";
import type { LoadedGroundValue } from "../common/computation-model/data";
import { isPrimitive } from "../common/computation-model/data";

export class DateTimeAsyncParser {
    private _waitingForParsing = false;

    protected parseDateTime(v: LoadedGroundValue, setAllDirty: () => void): Date | undefined {
        if (!isPrimitive(v)) return undefined;
        const maybeParsed = parseValueAsDate(v);
        if (maybeParsed instanceof Promise) {
            if (this._waitingForParsing) return undefined;

            this._waitingForParsing = true;
            setTimeout(async () => {
                try {
                    await maybeParsed;
                } finally {
                    setAllDirty();
                }
            }, 0);
            return undefined;
        } else {
            return maybeParsed;
        }
    }
}
